// Copyright 2016 Sorama B.V.

import { FrontEnd } from "datatypes/SoramaLocalApi";
import { ChannelSelection } from "services/ChannelSelection/ChannelSelection";
import { ChannelSelectionUsage } from "services/ChannelSelection/ChannelSelectionUsage";

export abstract class IChannelSelectionPresetService {
    /**
     * Get all pre-defined and custom channel selection presets
     * @param frontEnd FrontEnd device
     */
    public abstract getPresets(frontEnd: FrontEnd): ChannelSelection[];

    /**
     * Get a default channel selection
     * @param frontEnd FrontEnd device
     * @param usageHint Intended purpose of the channel selection (optional; default is live streaming)
     */
    public abstract getDefaultPreset(frontEnd: FrontEnd, usageHint?: ChannelSelectionUsage): ChannelSelection;

    /**
     * Get a specific channel selection when it's id is already known
     * @param frontEnd FrontEnd device
     * @param id Identifier of channel selection
     */
    public abstract getPresetById(frontEnd: FrontEnd, id: string): ChannelSelection;

    /**
     * Returns whether the channel selection is the default preset for the specified device and usage
     * @param selection Channel selection
     * @param frontEnd FrontEnd device
     * @param usageHint Intended purpose of the channel selection (optional; default is live streaming)
     */
    public abstract isDefaultPreset(
        selection: ChannelSelection,
        frontEnd: FrontEnd,
        usageHint?: ChannelSelectionUsage
    ): boolean;

    /**
     * Returns whether the channel selection is a custom preset (i.e. not pre-defined)
     * @param selection Channel selection
     * @param frontEnd FrontEnd device
     */
    public abstract isCustomPreset(selection: ChannelSelection, frontEnd: FrontEnd): boolean;
}
